/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TerminalScheduleItem } from './terminal_schedule_item'
import type { TerminalSpecification } from './terminal_specification'
/**
 * Терминал
 */
export type TerminalItem = {
  /**
   * Идентификатор терминала
   */
  id: string
  /**
   * Тип терминала (Terminal - обычный терминал, Pvz-Yarche - магазин Ярче)
   */
  type: TerminalItem.type
  /**
   * Название
   */
  name: string
  /**
   * Режим работы
   */
  schedule?: Array<TerminalScheduleItem>
  /**
   * Адрес
   */
  address: string
  /**
   * Список телефонов
   */
  phones?: Array<string>
  /**
   * Список Email'ов
   */
  emails?: Array<string>
  /**
   * Срок бесплатного хранения (в днях)
   */
  unpaidDays: number
  /**
   * Широта
   */
  latitude: string
  /**
   * Долгота
   */
  longitude: string
  /**
   * Является ли пунктом отправления
   */
  isDeparture: boolean
  /**
   * Является ли пунктом назначения
   */
  isDestination: boolean
  /**
   * Параметры, ограничения терминала
   */
  specification?: TerminalSpecification
  /**
   * Комментарий
   */
  comment?: string
}
export namespace TerminalItem {
  /**
   * Тип терминала (Terminal - обычный терминал, Pvz-Yarche - магазин Ярче)
   */
  export enum type {
    TERMINAL = 'terminal',
    PVZ_YARCHE = 'pvz-yarche'
  }
}
